import { ReactElement } from "react";
import Menu from "../../../Menu";
import ButtonHeader from "../../ButtonHeader";
import { Routes } from "@Front/Config/Routes";
import { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import { useOfficeMenuMatrixCan } from "../../hooks/useOfficeMenuMatrixCan";

interface OfficeMenuProps {
	/** Entrées office après garde-fous métier ; `Menu` applique la matrice (`useMatrixFilteredMenuItems`). */
	officeMenuCandidates: IItem[];
}

export function OfficeMenu({ officeMenuCandidates }: OfficeMenuProps): ReactElement | null {
	const officeMatrixCan = useOfficeMenuMatrixCan();
	return (
		<Menu items={officeMenuCandidates} openingSide="center" openOnHover matrixCan={officeMatrixCan}>
			<ButtonHeader
				text={"Espace office"}
				path={Routes.pages.Collaborators.base}
				routesActive={officeMenuCandidates.flatMap((item) => item.routesActive ?? [])}
				disabledLink
			/>
		</Menu>
	);
}
